import React, { useState, useEffect, forwardRef } from 'react';
import ImageShimmer from '../imageShimmer/ImageShimmer';

const LazyImage = forwardRef(({ 
  src, 
  alt, 
  className = '', 
  shimmerClassName = '',
  onLoad,
  onClick,
  onMouseMove,
  onMouseEnter,
  onMouseLeave,
  ...props 
}, ref) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    // Reset loading state when src changes
    setIsLoaded(false);
    setHasError(false);
    
    const img = new Image();
    img.src = src;
    
    img.onload = () => {
      setIsLoaded(true);
      if (onLoad) onLoad();
    };
    
    img.onerror = () => {
      setHasError(true);
    };
    
    return () => {
      img.onload = null;
      img.onerror = null;
    };
  }, [src, onLoad]);

  if (hasError) {
    return (
      <div className={`image-error ${className}`}>
        <span>Failed to load image</span>
      </div>
    );
  }

  return (
    <>
      {!isLoaded && (
        <ImageShimmer 
          className={shimmerClassName || className}
        />
      )}
      <img
        ref={ref}
        src={src}
        alt={alt}
        className={className}
        style={{ display: isLoaded ? 'block' : 'none' }}
        onClick={onClick}
        onMouseMove={onMouseMove}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        {...props}
        loading="lazy"
      />
    </>
  );
});

LazyImage.displayName = 'LazyImage';

export default LazyImage;
